module.exports = __webpack_public_path__ + "media/neutral.b6592b3a.wav";